import { Component, Input } from '@angular/core';
import { providerImage, DEFAULT_LOGO_PATH, DEFAULT_LOGO_UNKNOWN } from '@shared/models/logos';

@Component({
  selector: 'app-provider-image',
  templateUrl: './provider-image.component.html',
  styleUrls: ['./provider-image.component.scss']
})

export class ProviderImageComponent {
  @Input() providerName: string = '';
  logoFound: boolean = true;

  public imagePath(): string  {
    return this.logoFound
      ? DEFAULT_LOGO_PATH + providerImage(this.providerName)
      : DEFAULT_LOGO_PATH + DEFAULT_LOGO_UNKNOWN;
  }

  public imageError(): void {
    this.logoFound = false;
  }
}
